const icons = {
    instruction: {},
    picture: {},
};

export default icons;
